module.exports = __webpack_public_path__ + "img/logo-icon-white.dc6c84ec.png";